import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {Spacing} from 'types/Theme'

import {PageWidthContainer} from '@vio/atlas/helpers/PageWidthContainer'
import {Stack} from '@vio/atlas/helpers/Stack'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'
import minus from '@vio/atlas/utils/minus'
import {getIsRtlLanguage} from '@vio/core/src/auth/modules/selectors'
import {CashbackExplanationWidget} from '@vio/shared/src/cashback/components/CashbackExplanationWidget'

import {CarouselWidgetsProvider} from './context/CarouselWidgetsContext'
import {ExtendYourStay} from './ExtendYourStay/ExtendYourStay'
import {HopperAds} from './HopperAds/HopperAds'
import {RecentSearchHistory} from './RecentSearchHistory'
import {SuggestedHotels} from './SuggestedHotels'
import {TopDealsForTonight} from './TopDealsForTonight'
import {YourStays} from './YourStays'

const StyledPageWidthContainer = styled(PageWidthContainer)`
  display: flex;
  flex-direction: column;
  gap: ${cssTheme.layout.spacing.s800};
  padding: 0;

  margin-left: ${minus(cssTheme.layout.spacing.s400)};
  margin-right: ${minus(cssTheme.layout.spacing.s400)};
  margin-top: ${cssTheme.layout.spacing.s500} !important;
  margin-bottom: ${cssTheme.layout.spacing.s800} !important;

  ${linariaMq.desktopXs} {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
`

interface Props {
  hasContext?: boolean
  space?: Spacing
}

const SolidCarouselWidgets: React.FC<{space?: Spacing}> = ({
  space = 's800'
}) => {
  const isRtl = useSelector(getIsRtlLanguage) as boolean
  return (
    <StyledPageWidthContainer
      paddingDesktopXsSize="s500"
      paddingMobileSmSize="s400"
    >
      <Stack space={space}>
        <YourStays />
        <HopperAds />
        <ExtendYourStay />
        <SuggestedHotels />
        <RecentSearchHistory />
        <CashbackExplanationWidget isRtl={isRtl} />
        <TopDealsForTonight />
      </Stack>
    </StyledPageWidthContainer>
  )
}
export const CarouselWidgets: React.FC<Props> = ({
  hasContext = true,
  space = 's800'
}) => {
  if (hasContext)
    return (
      <CarouselWidgetsProvider>
        <SolidCarouselWidgets space={space} />
      </CarouselWidgetsProvider>
    )

  return <SolidCarouselWidgets space={space} />
}
